

import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from '@angular/common';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-unauthorized-access',
  standalone: false,
  templateUrl: './unauthorized-access.component.html',
  styleUrl: './unauthorized-access.component.scss'
})
export class UnauthorizedAccessComponent {

  user: any;

  constructor(private router: Router, private authenticationService: AuthService, private location: Location,) { }

  ngOnInit(): void {
    this.user = this.authenticationService.getUser();
  }

  goBackHome() {
    if (this.user) {
      switch (this.user?.role) {
        case "ADMIN":
        case "SUPER_ADMIN":
          this.router.navigate(["/admin/e-ticketing/ticket-generation-landing"]);
          break;

        case "SUPER_AGENT":
          this.router.navigate(["/user/transaction-history"]);
          break;

        default:
          this.router.navigate(["/user/404"]);
          return;
      }
    } else {
      this.router.navigate(['']);
    }
  }

  goBack(): void {
    this.location.back();
  }

}
